<template>
  <div class="empty-page"></div>
</template>
<script>
export default {
  name: 'emptyPage',
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$router.replace(from.path);
    });
  },
}
</script>



// WEBPACK FOOTER //
// src/components/emptyPage.vue